export const environment = {
  production: false,
  url: 'https://function-portalcertificado-dev.azurewebsites.net/api',
  apptoken: 'EWUKQbUiQU28WWSAS9YN'
};
